export default {
  /** 路由 */
  route: {
    首页: '首页',

    一级菜单: '一级菜单',
    二级菜单: '二级菜单',
  },

  /** 头部导航提示 */
  header: {
    systemTitle: '虚拟电厂管理系统',
    plat: '虚拟电厂管理系统',
    menuSearch: '菜单搜索',
    playSound: '播放声音',
    refresh: '刷新',
    fullscreen: '全屏',
    languageChange: '语言切换',
    zh: '中文',
    en: '英文',
    langMessage: '语言切换成功',
    themeChange: '主题切换',
    light: '绿',
    dark: '科技蓝',
    boldDark: '深暗色',
    themeMessage: '主题切换成功',
    layoutLogin: '退出登录'
  },

  /** placeholder */
  placeholder: {
    search: '请输入菜单名称',
  },

}
